import React from 'react';
import { UIActions, UIActionsContext } from '../../data-catalog-shared';

export type UIActionsToastProps = {
  readonly type: 'success' | 'info' | 'warning' | 'error';
  readonly text: string;
};

export class UIActionsToast extends React.Component<UIActionsToastProps> {

  public override render() {
    return (
      <UIActionsContext.Consumer>
        {uiActions =>
          <UIActionsToastInternal type={this.props.type} text={this.props.text} uiActions={uiActions} />
        }
      </UIActionsContext.Consumer>
    );
  }

}

type UIActionsToastInternalProps = UIActionsToastProps & {
  readonly uiActions: UIActions;
};

class UIActionsToastInternal extends React.Component<UIActionsToastInternalProps> {

  private toastId: number | null = null;

  public override componentDidMount() {
    this.popToast();
  }

  public override componentDidUpdate(prevProps: UIActionsToastInternalProps) {
    if (this.props.type !== prevProps.type || this.props.text !== prevProps.text || this.props.uiActions !== prevProps.uiActions) {
      this.popToast();
    }
  }

  public override componentWillUnmount() {
    this.closeToastIfOpen();
  }

  public override render() {
    return null;
  }

  private popToast() {
    this.closeToastIfOpen();
    this.toastId = this.props.uiActions.popToast(this.props.type, this.props.text);
  }

  private closeToastIfOpen() {
    if (this.toastId != null) {
      this.props.uiActions.closeToast(this.toastId);
      this.toastId = null;
    }
  }

}
